import request from '@/utils/request'

export function getActivityUrl() {
  return request({
    url: '/api/ecwechat/qrcode/create-url?page=subpackage_activity/pages/activity-detail/index&scene=activityId=216&ckey=Ip2cCA',
    method: 'post'
  })
}

export function channelInfo(channelCode) {
  return request({
    url: `/api/notice/send-history-record/channel-info/${channelCode}`
  })
}

export function getWorthUrl() {
  return request({
    url: '/api/ecwechat/qrcode/create-url?page=subpackage_chamber/pages/member-worth/index',
    method: 'post',
  })
}

/**
 * 获取h5跳转链接信息
 * @param {*} id 二维码id
 * @param {*} type 跳转类型 1 小程序，2 app
 * @returns
 */
export function getH5SkipConfig(id, type) {
  return request({
    url: '/api/ecwechat/ec/h5/getH5SkipConfigById',
    method: 'get',
    params: { id, type }
  })
}

/**
 * 获取app信息
 * @returns
 */
export function getAppVersionConfig(channel) {
  return request({
    url: 'https://yunxi-conf.9kd.com/9617cf2d1d60d81081d2383a53d40cfa/' + channel + '.json',
    method: 'get'
  })
}

/**
 * 上报快速入驻信息
 * @returns
 */
export function postFastEnterInfo(contactName, contactPhone, name) {
  return request({
    url: '/api/ecwechat/chamber/ysh-clue/wechatAuth/addClue',
    method: 'post',
    headers: {
      'code': 'h5'
    },
    data: {
      contactName, contactPhone, name
    }
  })
}

/**
 * 社会组织转介绍入驻 添加线索
 * @returns
 */
export function postIntroduceInfo(contactName, contactPhone, name, putSource) {
  return request({
    url: '/api/ecwechat/chamber/ysh-clue/wechatAuth/addPutClue',
    method: 'post',
    headers: {
      'code': 'h5'
    },
    data: {
      contactName, contactPhone, name, putSource
    }
  })
}

/**
 * 生成固定页面的短链
 * @returns
 */
export function getWxLink(page, scene) {
  return request({
    url: '/api/ecwechat/qrcode/create-url',
    method: 'post',
    params: { page, scene }
  })
}



/**
 * 生成优云电商固定页面的短链
 * @returns
 */
export function getYYWxLink(page, scene) {
  return request({
    url: 'https://yyds.kaidicloud.com/yywechat/wechat/creat-urlscheme',
    method: 'post',
    data: {
      page,
      scene
    }
  })
}

/**
 * 上报微信id
 * @returns
 */
export function postWxId(gdt_vid) {
  return request({
    url: '/api/ecwechat/api/wx/ad/user_actions/add',
    method: 'post',
    data: {
      gdt_vid
    }
  })
}

/**
 * 获取当前加入的商会
 * @returns
 */
export function getJoinChamber(token, page, pageSize) {
  return request({
    url: '/api/ecwechat/wechatAuth/my-joined-chamber',
    method: 'get',
    headers: {
      'code': 'h5',
      'token': token
    },
    params: { page, pageSize }
  })
}

/**
 * 招商入驻提交资料
 * @returns
 */
export function addInvestmentSettle(data) {
  return request({
    url: `/api/ecwechat/v1.0/wechat/investment-settle/save`,
    method: 'post',
    data
  })
}

/**
 * 根据kdopenid查询会员信息
 * @returns
 */
export function getMemberInfo(kdOpenId) {
  return request({
    url: `/api/ecwechat/wechat/member/${kdOpenId}`,
    method: 'get'
  })
}

/**
 * 验证url是否有效
 * @returns
 */
export function checkWapUrl(wapurl) {
  return request({
    url: wapurl,
    method: 'get'
  })
}

export function recruitment(data) {
  return request({
    url: `/api/ecwechat/ecological-partner/recruitment/save`,
    data,
    method: 'post'
  })
}

export function getBanners(params) {
  return request({
    url: `/api/ecwechat/ecological-topic/banners`,
    params
  })
}

export function getActivitySkipUrl(activityId) {
  return request({
    url: `/api/ecwechat/new-activity/activity-skip/${activityId}`
  })
}
